import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../api/client";
import BottomNav from "../components/BottomNav";

interface Training { id: number; course_id: number; course_title: string | null; status: string; assigned_at: string; completed_at: string | null; expires_at: string | null; }

export default function TrainingPage() {
  const { t } = useTranslation();
  const [rows, setRows] = useState<Training[]>([]);
  useEffect(() => { void (async () => { try { setRows(await api.get<Training[]>("/api/training/my")); } catch {} })(); }, []);

  const statusBadge = (s: string) => {
    const map: Record<string, string> = { not_started: "bg-gray-100 text-gray-600", in_progress: "bg-blue-50 text-blue-700", completed: "bg-green-50 text-green-700", expired: "bg-red-50 text-red-700", failed: "bg-red-50 text-red-700" };
    const label: Record<string, string> = { not_started: "Not Started", in_progress: "In Progress", completed: "Completed", expired: "Expired", failed: "Failed" };
    return <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${map[s] ?? "bg-gray-100"}`}>{label[s] ?? s}</span>;
  };

  return (
    <div className="flex min-h-dvh flex-col bg-white safe-x">
      <header className="safe-top px-5 pt-4 pb-3">
        <h1 className="text-2xl font-semibold text-gray-900">{t("nav.training")}</h1>
      </header>
      <main className="flex-1 overflow-y-auto px-5 pb-24 space-y-2">
        {rows.length === 0 && <p className="text-sm text-gray-400">{t("common.noData")}</p>}
        {rows.map((r) => (
          <div key={r.id} className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="text-sm font-semibold text-gray-900">{r.course_title}</p>
                <p className="text-xs text-gray-500">{r.assigned_at ? new Date(r.assigned_at).toLocaleDateString() : ""}</p>
              </div>
              {statusBadge(r.status)}
            </div>
            {r.expires_at && <p className="mt-1 text-xs text-amber-600">Expires: {new Date(r.expires_at).toLocaleDateString()}</p>}
          </div>
        ))}
      </main>
      <BottomNav />
    </div>
  );
}
